<div class="status-badge" [ngClass]="badgeClass">
  @if (shouldShowIcon) {
    <mat-icon class="status-icon">
      {{ icon }}
    </mat-icon>
  }

  <span class="badge-text">{{ displayText }}</span>
</div>
